/** Must match host `<main aria-labelledby="…">` (e.g. contentWrapper). */
export const PAGE_TITLE_ID = 'pageTitleHeaderText';
export const ZERO_WIDTH_SPACE = '‎';
export const APP_CONTAINER_ID = 'spaRootContainer';
export const NOTIFICATIONS = Object.freeze({
    delayMs: 10000,
    maxDisplayed: 10,
});
export const initialBootConfig = {
    featureFlags: {
        f1034519_SkipLessonTemplateForIndividualStudent: false,
        f144478_SkipLessonsWithDroppedAssessments: false,
        f144428_MultipleSkipDropTemplatesPerCourse: false,
    },
    apiBaseUrl: '',
    appSpaBaseUrl: '',
    loggedWebuserFirstName: 'Antonio',
    loggedWebuserLastName: 'Teacher',
    loggedWebuserId: 4668277,
    idSection: 0,
    idWebuser: 0,
    webuserName: '',
    returnUrl: '',
    courseId: 0,
    sectionType: '',
};
export const ROUTES = {
    lessonCompletion: '/lessoncompletion',
    sectionsAndStudents: '/sectionsandstudents#/mystudents',
    achievementTokens: '/achievementTokens',
};
